import {ChartType} from 'common/report/constants';
import {ChartPlotStyle} from 'common/report/insights/util/types';

export const CHART_OPTIONS = {
  [ChartType.Bar]: {
    [ChartPlotStyle.Standard]: {name: `Bar`, icon: `bar`},
    [ChartPlotStyle.Stacked]: {name: `Stacked bar`, icon: `bar-stacked`},
  },
  [ChartType.Line]: {
    [ChartPlotStyle.Standard]: {name: `Line`, icon: `line`},
    [ChartPlotStyle.Stacked]: {name: `Stacked line`, icon: `stacked-line`},
  },
  [ChartType.Pie]: {
    [ChartPlotStyle.Standard]: {name: `Pie`, icon: `pie`},
  },
  [ChartType.Table]: {
    [ChartPlotStyle.Standard]: {name: `Table`, icon: `table`},
  },
  [ChartType.Metric]: {
    [ChartPlotStyle.Standard]: {name: `Metric`, icon: `single-metric`},
  },
  [ChartType.FunnelSteps]: {
    [ChartPlotStyle.Standard]: {name: `Funnels Steps`, icon: `funnel-steps`},
  },
};

export const FLATTENED_CHART_TYPES = [ChartType.Line, ChartType.Pie, ChartType.Metric];

export const MAX_TABLE_ROWS = 5000;
export const MAX_PIE_LABELS = 6;

export const DOWNLOAD_ROW_LIMIT = 30;
export const DOWNLOAD_LINE_LIMIT = 12;

export const MAX_Y_AXIS_RELATIVE_VALUE = 100;
